import React from 'react';

import { Alert } from '@chargify/custom-ui-components';

import { AffectedSubscription } from '../../../machines/deletePaymentProfile';
import { SubscriptionNamesList } from './ErrorList.styles';

type ErrorListProps = {
  items: AffectedSubscription[];
  listTitle: string;
  listDescription: string;
  bottomText: string;
};

export const ErrorList = ({
  listTitle,
  items,
  bottomText,
  listDescription,
}: ErrorListProps) => {
  return (
    <>
      <Alert color={'danger'}>
        <Alert.TextMessage fontWeight={700}>{listTitle}</Alert.TextMessage>
        <Alert.TextMessage>{listDescription}</Alert.TextMessage>
        <SubscriptionNamesList>
          {items.map(({ id, product }) => (
            <Alert.TextMessage as={'li'} key={id}>
              {product.name}
            </Alert.TextMessage>
          ))}
        </SubscriptionNamesList>
        <Alert.TextMessage fontWeight={700}>{bottomText}</Alert.TextMessage>
      </Alert>
    </>
  );
};
